import { Typography } from '@doveit/lego';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import Image from 'next/image';
import { AgentStory as AgentStoryModel } from '../../../domain/graphcms';
import Markdown from '../markdown/Markdown';
import * as styles from './AgentStory.style';

export interface AgentStoryProps {
  story: AgentStoryModel,
  hideInterview?: boolean,
}
const AGENT_STORY_IMAGE_WIDTH = 140;
const AGENT_STORY_IMAGE_HEIGHT = 140;

const AgentStory: FunctionComponent<AgentStoryProps> = ({
  story,
  hideInterview,
}) => {
  const { agent } = story;
  return (
    <div>
      <div css={styles.wrapper}>
        <div css={styles.infoBox}>
          <div css={styles.picture}>
            <Image
              src={agent.photo.url}
              width={AGENT_STORY_IMAGE_WIDTH}
              height={AGENT_STORY_IMAGE_HEIGHT}
              alt={`Foto di ${agent.name} ${agent.surname}`}
            />
          </div>
          <div>
            <Typography.H3 color="brand.primary">
              {agent.name} {agent.surname}
            </Typography.H3>
            <div css={styles.jobTitle}>
              {agent.jobTitleType.name} - {agent.area}
            </div>
          </div>
        </div>
        <Markdown css={styles.bio}>
          {story.bio}
        </Markdown>
      </div>
      <Markdown css={styles.quote}>
        {`“${story.quote}”`}
      </Markdown>
      {!hideInterview && agent.interview && (
        <div css={styles.link}>
          <Link href={agent.interview}>
            Leggi l&apos;intervista completa
          </Link>
        </div>
      )}
    </div>
  );
};

export default AgentStory;
